// Font sizing only. Never changes handlers, data, button dimensions or ordering.
export function installDisplayFit(root=document){
 const win=root.defaultView||window,base=new WeakMap();let queued=0,closed=false;
 if(!win.MutationObserver||!win.requestAnimationFrame||!root.body)return()=>{};
 const selectors='.opcards-nav button,.opcards-tabs button,.opcards-shell header button,.opcards-step strong,.opcards-step small,.opcards-step>span,.opcards-current-step button,.opcards-intro-actions button,.opcards-intro-modal header button';
 function fit(){queued=0;if(closed)return;
  root.querySelectorAll(selectors).forEach(el=>{
   if(/^zh/i.test(root.documentElement.lang)){if(base.has(el)){el.style.removeProperty('font-size');base.delete(el);}return;}
   if(!el.getClientRects().length)return;
   const style=win.getComputedStyle(el),initial=base.get(el)||parseFloat(style.fontSize);base.set(el,initial);
   el.style.fontSize=initial+'px';
   const range=root.createRange();range.selectNodeContents(el);
   const width=el.clientWidth-parseFloat(style.paddingLeft)-parseFloat(style.paddingRight);
   let size=initial;
   while(size>8&&(range.getBoundingClientRect().width>width+1||el.scrollWidth>el.clientWidth+1)){size-=.5;el.style.fontSize=size+'px';}
  });
 }
 function schedule(){if(!closed&&!queued)queued=win.requestAnimationFrame(fit);}
 const observer=new win.MutationObserver(schedule);observer.observe(root.body,{childList:true,subtree:true,characterData:true});
 win.addEventListener('resize',schedule);schedule();
 if(root.fonts&&root.fonts.ready)root.fonts.ready.then(schedule);
 return()=>{closed=true;observer.disconnect();win.removeEventListener('resize',schedule);if(queued)win.cancelAnimationFrame(queued);};
}
